import axios from 'axios'
import qs from 'qs'
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from '../../urlLink'
import {isGraySchoolEnabled} from "@/bootstrap/graySchoolRouting";
const root = Urls.crmApiUrl //域名
    //首页数据请求
const url = {
    getSellgoal: root + "/Sellgoal",
    getSellgoalExport: root + "/Sellgoal/Export",
    getgoalOne: root + "/Sellgoal/goalOneApi",
    goalCheckMarketer: root + "/Sellgoal/goalCheckMarketerApi",
    goalFinishStatus: root + "/Sellgoal/goalFinishStatusApi",
    goalFinishRate: root + "/Sellgoal/goalFinishRateApi",
    addGoal: root + "/Sellgoal/addGoalAction",
    updateGoal: root + "/Sellgoal/updateGoalAction",
    getgoalMy: root + "/Sellgoal/goalMy",
    getgoalMyExport: root + "/Sellgoal/goalMy/Export",
    getsellActivity: root + "/Sellgoal/sellActivity",
    getgoalActivityOne: root + "/Sellgoal/goalActivityOneApi",
    addGoalActivity: root + "/Sellgoal/addGoalActivityAction",
    getgoalFounder: root + "/Sellgoal/goalFounderApi",
    updateGoalActivity: root + "/Sellgoal/updateGoalActivityAction",
    getActivityFounder: root + "/Sellgoal/ActivityFounderApi",
    delGoal: root + "/Sellgoal/delGoalAction",
    delGoalActivity: root + "/Sellgoal/delGoalActivityAction",
    copyActivityOneApi: root + "/Sellgoal/copyActivityOneApi",
    ActivityCoursecatApi: root + "/PhoneActivity/ActivityCoursecatApi",

}
const storeGoalmanage = {
    // 招生目标管理 
    getSellgoal(params) {
        return axios.get(url.getSellgoal, { params })
    },
    ActivityCoursecatApi(params) {
        return axios.get(url.ActivityCoursecatApi, { params })
    },
    // 招生目标管理 ----导出
    getSellgoal1() {
        return isGraySchoolEnabled()? url.getSellgoalExport: url.getSellgoal
    },
    // 单个招生目标查看
    getgoalOne(params) {
        return axios.get(url.getgoalOne, { params })
    },
    // 参与目标考核的所有员工 
    getgoalCheckMarketer(params) {
        return axios.get(url.goalCheckMarketer, { params })
    },
    // 某目标参与成员的线索转正数
    getgoalFinishStatus(params) {
        return axios.get(url.goalFinishStatus, { params })
    },
    // 某目标参与成员的跟踪柜询完成率
    getgoalFinishRate(params) {
        return axios.get(url.goalFinishRate, { params })
    },
    // 目标创建人管理 
    getgoalFounder(params) {
        return axios.get(url.getgoalFounder, { params })
    },
    // 目标创建人管理 
    getActivityFounder(params) {
        return axios.get(url.getActivityFounder, { params })
    },
    // 添加招生目标
    addGoal(params) {
        return axios.post(url.addGoal, qs.stringify(params))
    },
    // 修改招生目标 
    updateGoal(params) {
        return axios.post(url.updateGoal, qs.stringify(params))
    },
    // 删除招生目标 
    delGoal(params) {
        return axios.post(url.delGoal, qs.stringify(params))
    },
    // 我的招生目标管理
    getgoalMy(params) {
        return axios.get(url.getgoalMy, { params })
    },
    // 我的招生目标管理---导出
    getgoalMy1() {
        return isGraySchoolEnabled()?url.getgoalMyExport:url.getgoalMy
    },
    // 招生活动管理 
    getsellActivity(params) {
        return axios.get(url.getsellActivity, { params })
    },
    // 单个招生活动查看
    getgoalActivityOne(params) {
        return axios.get(url.getgoalActivityOne, { params })
    },
    // 添加招生活动目标
    addGoalActivity(params) {
        return axios.post(url.addGoalActivity, qs.stringify(params))
    },
    // 单个招生活动 修改 
    updateGoalActivity(params) {
        return axios.post(url.updateGoalActivity, qs.stringify(params))
    },
    // 单个招生活动 删除
    delGoalActivity(params) {
        return axios.post(url.delGoalActivity, qs.stringify(params))
    },
    // 复制活动
    copyActivityOneApi(params) {
        return axios.post(url.copyActivityOneApi, qs.stringify(params))
    },

}

export default storeGoalmanage;